import React, { FC, useMemo } from 'react'

import { CurrencyCell, NumberCell } from 'core/table/cells'
import SummaryCards from 'core/table/components/SummaryCards'
import useChampionSummary from '../hooks/useChampionSummary'
import { useNationalAvgVolunteerValuePerHour } from 'champion/hooks/useNationalAvgVolunteerValuePerHour'

export interface Props {
  volunteers: any
}

export const ChampionsSummaryCards: FC<Props> = props => {
  const { volunteers } = props
  const valuePerHour = useNationalAvgVolunteerValuePerHour()
  const summary = useChampionSummary(volunteers, valuePerHour)
  const cards = useMemo(
    () => [
      {
        Header: 'Champions',
        accessor: 'count',
        Cell: NumberCell,
      },
      {
        Header: 'Hours',
        accessor: 'totalHours',
        Cell: NumberCell,
      },
      {
        Header: 'Donations',
        accessor: 'totalDonations',
        Cell: CurrencyCell,
      },
      {
        Header: 'Estimated Impact',
        accessor: 'estimatedImpact',
        Cell: CurrencyCell,
        toolTipText: `This value was calculated using the national average of $${valuePerHour} / hour for volunteers.`,
      },
    ],
    [valuePerHour],
  )

  return <SummaryCards cards={cards} summary={summary} />
}
